import { t } from 'ttag'

import * as gameboardActions from '../../actions/earlyGameboard'
import * as earlyListingActions from '../../actions/early/earlyListing'
import * as observers from '../../observers'
import * as h2Api from '../../h2Api'

const generateLevels = () => {
  return {
    1: {
      name: t`Intern`,
      promotionText: [
        t`Congratulations, you have just been promoted to Associate! You can now access the budget found on the gameboard.`,
        t`To advance to the next level, you'll need to complete the budget, explore at least 10 occupations and like at least 5 of them.`
      ],
      requiresReflection: true,
      reflectionQuestion: t`Great Job! Now that you have found a few pathways that you like, tell us what made you choose them?`
    },
    2: {
      name: t`Associate`,
      promotionText: [
        t`Congratulations, you have just been promoted to Manager! You can now access the presentation found on the gameboard.`,
        t`To advance to the next level, you'll need to complete a presentation.`
      ],
      requiresReflection: true,
      reflectionQuestion: t`Almost there! You have found at a few occupations you like, tell us what made you choose them?`
    },
    3: {
      name: t`Manager`,
      promotionText: [
        t`Congratulations, your final promotion has been approved! You are now the Boss.`
      ],
      requiresReflection: false
    },
    4: {
      name: t`The Boss`,
      promotionText: [],
      requiresReflection: false
    },
    5: {
      name: t`The Boss`,
      promotionText: [],
      requiresReflection: false
    }
  }
}
const getCurrentLevelFromResult = inp => {
  let levelId = 1
  const summary = {}
  const levels = generateLevels()

  if (inp.level1CompletionDate) {
    summary.l1 = { level: levels[1].name }
    levelId = 2
  }

  if (inp.level2CompletionDate) {
    levelId = 3
    summary.l2 = { level: levels[2].name }
  }

  if (inp.level3CompletionDate) {
    levelId = 4
    summary.l3 = { level: levels[3].name }
    summary.l4 = { level: levels[4].name }
  }

  if (inp.level4CompletionDate) {
    levelId = 5
    summary.l4 = { level: levels[4].name }
  }

  return { levelId, summary }
}
const generateJobZones = () => {
  return {
    1: {
      id: 1,
      description: t`No formal education is required, and you can do the job with some training at work`,
      budgetDescription: t`I will get a job as soon as I can`
    },
    2: {
      id: 2,
      description: t`You will need to graduate high school before you get a job`,
      budgetDescription: t`I will finish high school, then get a job`
    },
    3: {
      id: 3,
      description: t`You will need to get specialized training, usually from a trade school or community college`,
      budgetDescription: t`I will get some training, then get a job (2+ years)`
    },
    4: {
      id: 4,
      description: t`You will usually need a college degree before you can get a job`,
      budgetDescription: t`I will graduate from college and then get a job (4+ years)`
    },
    5: {
      id: 5,
      description: t`You will need college and an advanced degree, like a master's degree, Ph.D., M.D., or J.D. (law degree)`,
      budgetDescription: t`I will go to college, then get an advanced degree, and then get a job (6+ years)`
    }
  }
}
const initialState = {
  loadedGameId: 0,
  dynClasses: {},
  isPopupOpened: false,
  isHelpPopupOpened: false,
  help: {
    collection: {},
    currentSection: 0
  },
  isHome: false,
  isSearchPopupOpened: false,
  gameBoardContainer: {
    className: ``,
    type: ''
  },
  spinner: {
    className: ``
  },
  userInfo: {
    name: dynamicValues.userProfile?.userDisplayName || '',
    avatar: '/images/common/earlyexploration/Avatars/avatar-01.svg'
  },
  clusters: [],
  jobZones: {},
  levels: generateLevels(),
  activityLog: {
    loadingState: 0,
    dataLoaded: false,
    pathways: [],
    clusters: [],
    occupations: [],
    activities: [],
    clustervideo: []
  },
  progress: {
    level: t`Intern`,
    levelId: 1,
    summary: {}
  },
  isBadgePopupOpened: false,
  badgeModal: {
    title: null,
    description: null,
    icon: null,
    modalClass: null
  },
  isLevelPopupOpened: false,
  levelModal: {
    title: null,
    description: null
  },
  badges: {
    pathways: {},
    budget: {},
    occupations: {},
    assessment: {},
    rating: {},
    user: {},
    clusterVideos: {}
  },
  tutorial: {
    currentStep: 1,
    isOpen: true
  }
}
const earlyGameboard = (state = initialState, action) => {
  switch (action.type) {
    case gameboardActions.TOGGLE_AVATAR:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          avatar: action.fileId
        }
      }

    case earlyListingActions.LOAD_GAME:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.FETCHING) {
        return {
          ...state,
          activityLog: {
            ...state.activityLog,
            loadingState: 1
          }
        }
      }

      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const v = {
          ...state,
          loadedGameId: action.restCall.result.id,
          includeOccupationVideos: action.restCall.result.includeOccupationVideos,
          tutorial: {
            ...state.tutorial,
            isOpen: !action.restCall.result.setup
          },
          userInfo: {
            avatar: action.restCall.result.avatarUrl,
            name: action.restCall.result.name
          },
          badges: {
            ...state.badges,
            ...action.restCall.result.badges
          },
          progress: {
            ...state.progress,
            ...getCurrentLevelFromResult(action.restCall.result)
          },
          activityLog: {
            ...state.activityLog,
            ...action.restCall.result.history,
            loadingState: 2
          },
          clusters:
            action.restCall.result?.clusterProfiles.map(c => ({
              id: c.id,
              name: c.name
            })) ?? [],
          jobZones: generateJobZones(),
          levels: generateLevels()
        }

        return v
      }

      return state

    case earlyListingActions.TOGGLE_LOADING:
      return {
        ...state,
        activityLog: {
          ...state.activityLog,
          loadingState: 3,
          dataLoaded: action.dataLoaded
        }
      }

    case observers.PRE_LEVEL:
      return {
        ...state,
        isLevelPopupOpened: !!action.levelContent,
        levelModal: action.levelContent
      }

    case observers.QUIET_SET_LEVEL:
      return {
        ...state,
        progress: {
          ...state.progress,
          levelId: action.levelId
        }
      }

    case observers.SET_LEVEL:
      let levelModal = {
        isLevelPopupOpened: false,
        levelModal: null
      }

      if (action.levelContent) {
        levelModal = {
          isLevelPopupOpened: state.activityLog.dataLoaded,
          levelModal: action.levelContent
        }
      }

      return {
        ...state,
        progress: {
          ...state.progress,
          levelId: action.levelId
        },
        ...levelModal
      }

    case gameboardActions.TOGGLE_LEVEL_MODAL:
      return {
        ...state,
        isLevelPopupOpened: false
      }

    case observers.BADGES_UPDATED:
      if (state.activityLog.dataLoaded && action.modalContent) {
        return {
          ...state,
          badgeModal: action.modalContent,
          isBadgePopupOpened: true,
          badges: action.badges
        }
      }

      return {
        ...state,
        badges: action.badges
      }

    case gameboardActions.TOGGLE_BADGE_MODAL:
      return {
        ...state,
        isBadgePopupOpened: false
      }

    case gameboardActions.SET_SPINNER_HOVER:
      return {
        ...state,
        spinner: {
          ...state.spinner,
          className: action.className
        }
      }

    case gameboardActions.REGISTER_VIEW:
      const newArray = state.activityLog[action.activityKey]
      let key = 'unknown'

      if (action.activityValue.hasOwnProperty('occupationId')) {
        key = action.activityValue.occupationId
      } else if (action.activityValue.hasOwnProperty('pathwayId')) {
        key = action.activityValue.pathwayId
      } else if (action.activityValue.hasOwnProperty('clusterId')) {
        key = action.activityValue.clusterId
      } else if (action.activityValue.hasOwnProperty('id')) {
        key = action.activityValue.id
      } else if (action.activityValue.hasOwnProperty('videoId')) {
        key = action.activityValue.videoId
      }

      const filteredLog = newArray.filter(n => n.key !== key)
      const newState = {
        ...state,
        activityLog: {
          ...state.activityLog,
          [action.activityKey]: [
            ...filteredLog,
            {
              key,
              dateAdded: new Date(),
              value: action.activityValue
            }
          ]
        }
      }

      return newState

    case gameboardActions.TOGGLE_TUTORIAL_MODAL:
      return {
        ...state,
        tutorial: {
          ...state.tutorial,
          isOpen: !state.tutorial.isOpen
        }
      }

    case gameboardActions.TOGGLE_USER_MODALS_OFF:
      return {
        ...state,
        isHelpPopupOpened: false,
        isSearchPopupOpened: false,
        isPopupOpened: false
      }

    case gameboardActions.TOGGLE_HELP_MODAL:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          help: {
            ...state.help,
            collection: action.restCall.result,
            currentSection: 1
          },
          isHelpPopupOpened: !state.isHelpPopupOpened
        }
      }

      return state

    case gameboardActions.TOGGLE_SEARCH_MODAL:
      return {
        ...state,
        isSearchPopupOpened: !state.isSearchPopupOpened
      }

    case gameboardActions.ADVANCE_TUTORIAL:
      return {
        ...state,
        tutorial: {
          ...state.tutorial,
          currentStep: state.tutorial.currentStep + 1
        }
      }

    case gameboardActions.TOGGLE_AVATAR_MODAL:
      return {
        ...state,
        isPopupOpened: !state.isPopupOpened
      }

    case gameboardActions.EDIT_GAMEBOARD_FIELD_CHANGE:
      const newFieldValues = { ...state.userInfo, ...action.fieldValue }

      return {
        ...state,
        userInfo: newFieldValues
      }

    case gameboardActions.TOGGLE_IS_HOME:
      return {
        ...state,
        isHome: action.val
      }

    case gameboardActions.TOGGLE_GAMEBOARD_CLASS:
      return {
        ...state,
        dynClasses: {
          ...state.dynClasses,
          [action.componentId]: action.className
        }
      }

    default:
      return state
  }
}

export default earlyGameboard
